// @ts-nocheck
import React from 'react';
import { WarehouseForm } from './WarehouseForm';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Warehouse } from 'lucide-react';
import { ModalBreadcrumbHeader } from '@/components/shared/ModalBreadcrumbHeader';

export interface WarehouseFormModalProps {
  open?: boolean;
  onClose?: () => void;
  onSuccess?: (newItem: { id: string; label: string; original?: any }) => void;
  onCancel?: () => void;
  warehouseId?: string;
  mode?: 'create' | 'edit';
  initialData?: any;
  breadcrumb?: string[];
}

function cleanWarehouseBreadcrumbs(crumbs?: string[], fallback = 'Kho hàng'): string[] {
  if (!crumbs || crumbs.length === 0) return [fallback];
  const mapped = crumbs.map((c) => {
    if (c === 'Thêm mới kho' || c === 'Thêm kho mới' || c === 'Cập nhật kho hàng') return 'Kho hàng';
    return c;
  });
  return mapped.filter((c, i) => i === 0 || c !== mapped[i - 1]);
}

export default function WarehouseFormModal({
  open,
  onClose,
  onSuccess,
  onCancel,
  warehouseId,
  mode,
  initialData,
  breadcrumb,
}: WarehouseFormModalProps) {
  const isEdit = !!warehouseId || mode === 'edit';

  const handleClose = () => {
    if (onCancel) onCancel();
    if (onClose) onClose();
  };

  const handleSuccess = (newItem: { id: string; label: string; original?: any }) => {
    if (onSuccess) {
      onSuccess(newItem);
    }
    if (onClose) onClose();
  };

  const content = (
    <div className="space-y-3">
      <DialogHeader className="sr-only">
        <DialogTitle>{isEdit ? 'Cập nhật Kho hàng' : 'Thêm mới Kho hàng'}</DialogTitle>
      </DialogHeader>

      <ModalBreadcrumbHeader
        breadcrumbs={cleanWarehouseBreadcrumbs(breadcrumb, isEdit ? 'Cập nhật kho hàng' : 'Thêm mới kho hàng')}
        title={isEdit ? 'Cập nhật kho hàng' : 'Thêm mới kho hàng'}
        icon={Warehouse}
        iconColor="text-amber-600"
      />

      <div className="pt-2">
        <WarehouseForm
          isModal={true}
          id={warehouseId}
          initialData={initialData}
          onSuccess={handleSuccess}
          onCancel={handleClose}
          submitLabel={isEdit ? 'Cập nhật kho' : 'Tạo mới kho'}
        />
      </div>
    </div>
  );

  // When used as standalone modal with explicit open/onClose
  if (open !== undefined && onClose !== undefined) {
    return (
      <Dialog open={open} onOpenChange={(val) => !val && handleClose()}>
        <DialogContent className="w-[95vw] sm:max-w-2xl md:max-w-3xl lg:max-w-3xl xl:max-w-4xl max-h-[92vh] overflow-y-auto p-4 sm:p-6">
          {content}
        </DialogContent>
      </Dialog>
    );
  }

  // When embedded in ComboboxFK which supplies its own Dialog
  return content;
}

export { WarehouseFormModal };
